export const formatCep = (value: string) => {
  const separate = value.split(":");

  return separate[1];
};

export const formatPhone = (value: string) => {
  if (value.includes(")")) {
    const separate = value.split(")");

    let phone = "";

    const secondNumber = separate[1].split("-");

    if (secondNumber[1].length > 4) {
      const separ = secondNumber[1].substring(0, 1);
      const separ2 = secondNumber[1].substring(1);

      phone = `${separate[0]}) ${secondNumber[0]}${separ}-${separ2}`;
    } else {
      phone = `${separate[0]}) ${separate[1]}`;
    }
    return phone;
  } else {
    const ddd = "011";
    const formattedNumber = `(${ddd}) ${value.slice(0, 4)}-${value.slice(4)}`;
    return formattedNumber;
  }
};

export const formattedInsuranceNumber = (number: number) => {
  // Converte o número para string, se ainda não for
  let numberStr = number.toString();

  // Aplica a regex para formatar o número
  let formattedNumber = numberStr.replace(
    /(\d{3})(\d{3})(\d{2})(\d{1})/,
    "$1.$2/$3-$4"
  );

  return formattedNumber;
};
